import { render, staticRenderFns } from "./paystatus.vue?vue&type=template&id=97bc153c&"
import script from "./paystatus.vue?vue&type=script&lang=js&"
export * from "./paystatus.vue?vue&type=script&lang=js&"
import style0 from "./paystatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports